
import { supabase } from '../supabase';

const THEME_KEY = 'equilibra_theme';

export const googleAuth = {
  async login() {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        queryParams: {
          access_type: 'offline',
          prompt: 'select_account',
        },
        scopes: 'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/calendar.events',
        redirectTo: window.location.origin
      }
    });
    if (error) throw error;
  },

  async logout() {
    // 1. Destrói sessão no servidor Supabase
    await supabase.auth.signOut();
    
    // 2. Limpa cookies de forma agressiva (Overwrite)
    document.cookie = "sb-secure-session=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Strict";
    
    // 3. Limpa memórias voláteis
    sessionStorage.clear();
    
    // 4. Limpa caches de UI (não sensíveis)
    localStorage.removeItem('equilibra_status_cache');
    localStorage.removeItem('equilibra_privacy_mode');
    
    // 5. Redireciona e limpa a URL para evitar vazamento de tokens via fragmento (#)
    window.location.href = window.location.origin;
  },

  async getSession() {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) return null;
    return session;
  },

  async getGoogleToken() {
    const session = await this.getSession();
    return session?.provider_token || null;
  },

  getTheme: () => localStorage.getItem(THEME_KEY) || 'light',
  setTheme: (theme: 'light' | 'dark') => localStorage.setItem(THEME_KEY, theme),
};
